import React from 'react'
import ProgressSimple from '../../pb_progress_simple/_progress_simple'

const ProgressSimpleValue = () => {
  return (
    <div>
      <ProgressSimple
          percent={40}
          width="100px"
      />
    </div>
  )
}

export default ProgressSimpleValue
